var React = require('react');

function Send (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".faa714ec-3e9e-446e-adea-9c37ef18775a{fill:#fff;}")),React.createElement("g",{"id":"ecc0c665-9009-4294-a436-1f820a75da6c","data-name":"Layer 2","key":1},React.createElement("g",{"id":"f8274045-8dd8-4d7b-9517-b0a415339d54","data-name":"Layer 1"},React.createElement("path",{"className":"faa714ec-3e9e-446e-adea-9c37ef18775a","d":"M.01,18,21,9,.01,0,0,7,15,9,0,11Z"})))]);
}

Send.defaultProps = {"width":"21","height":"18","viewBox":"0 0 21 18"};

module.exports = Send;

Send.default = Send;
